<template>
  <div>
    <b-notification
      v-for="(error, index) in errors"
      :key="index"
      type="is-danger"
      aria-close-label="Close notification"
      role="alert"
    >
      {{ error.message }}
    </b-notification>

    <div class="formcontainer">
      <b-field :label="$t('auth.verificationCode')">
        <b-input v-model="form.authCode" />
      </b-field>
      <b-field>
        <button
          type="submit"
          :disabled="$v.form.$invalid"
          class="button is-black centered"
          v-on:click="confirmSignUp"
        >
          {{ $t('auth.confirmAccount') }}
        </button>
      </b-field>
    </div>
    <section>
      <b-field>
        <div class="control" style="margin-top: 10px;">
          <p>
            <a v-on:click="resendConfirmation" class="customLink">
              {{ $t('auth.haventRecived?SendAgain') }}
            </a>
          </p>
        </div>
      </b-field>
    </section>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify'
import { required, email, sameAs } from 'vuelidate/lib/validators'

export default {
  name: 'confirm',
  props: ['email'],
  components: {},
  computed: {},
  data() {
    return {
      errors: [],
      form: {
        username: '',
        authCode: ''
      }
    }
  },
  validations: {
    form: {
      authCode: { required }
    }
  },
  methods: {
    goToSignIn() {
      this.$router.push({ name: 'sign-in' })
    },
    async resendConfirmation() {
      let self = this
      await Auth.resendSignUp(self.email)
        .then(function() {
          self.$toast.open({
            duration: 5000,
            message: self.$t(`auth.verificationCodeResended`),
            position: 'is-bottom',
            type: 'is-success'
          })
        })
        .catch(err => self.errors.push(err))
    },
    async confirmSignUp() {
      let self = this
      await Auth.confirmSignUp(self.email, self.form.authCode)
        .then(function() {
          self.$toast.open({
            duration: 5000,
            message: self.$t(
              `Cuenta creada correctamente. Ya puedes iniciar sesión`
            ),
            position: 'is-bottom',
            type: 'is-success'
          })
          self.$router.push({
            name: 'sign-in'
          })
        })
        .catch(err => self.errors.push(err))
    }
  }
}
</script>

<style>
.formcontainer {
  display: flex;
  flex-direction: column;
  width: 500px;
  margin: 0 auto;
}
.input {
  margin-bottom: 7px;
  height: 38px;
  border: none;
  outline: none;
  border-bottom: 2px solid #ddd;
  font-size: 20px;
}
</style>
